import React, { useState } from "react";
import forgotpassword from "../../../assets/images/LoginPicture/forgotpassword.png";
import checkEmail from "../../../assets/images/LoginPicture/checkEmail.png";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import Mask from "../../../assets/images/LoginPicture/Mask.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../axios";
// import axiosInstance from "../../../axios";
const ForgotPassword = () => {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState("");

  //Logic for forgot password

  const onSubmit = async (data) => {
    console.log("forgot email is ", data?.email);
    try {
      const response = await axiosInstance.post(
        "auth/admin/forgot-pasword",
        data
      );
      // Process the response or store any necessary data
      console.log("Forgot Response", response?.data?.success);
      if (response?.data?.success) {
        toast.success("Email sent to your Email id.");
        setEmailSent(true);
        setEmail(data?.email);
      }
    } catch (error) {
      // Handle the error and display a meaningful message
      console.error("Forgot password Error", error?.response?.data?.message);
    }
  };

  //when forgot password screen has to be shown
  const forgotPasswordCode = (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background:
          "linear-gradient(180deg, #000000 12.64%, rgba(255, 255, 255, 0) 200.18%)",
      }}
    >
      <div
        style={{
          zIndex: "1",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "26rem",
          height: "auto",
          padding: "2rem",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        <div>
          <img src={forgotpassword} alt="Login Top" />
        </div>
        <div
          style={{
            marginTop: "1.5rem",
            fontweight: "600",
            fontSize: "1.5rem",
            color: "#333333",
          }}
        >
          <h4>Dev Labs Alliance</h4>
        </div>
        <div style={{ marginTop: "1.5rem" }}>
          <span
            style={{ fontweight: "600", fontSize: "1.5rem", color: "#333333" }}
          >
            <h5>Forgot Password</h5>
          </span>
        </div>
        <div
          style={{ fontWeight: "600", marginTop: ".5rem", color: "#333333" }}
        >
          Enter email to reset your password
        </div>
        {/* Form component here */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: ".6rem",
            }}
          >
            <label style={{ marginBottom: ".6rem", marginTop: "1rem" }}>
              <span style={{ fontweight: "700" }}>Email</span>
            </label>
            <input
              type="email"
              {...register("email")}
              style={{
                width: "20rem",
                padding: ".6rem",
                height: "2.8rem",
                border: "1px solid #D9D9D9",
                outline: "none",
              }}
              placeholder="Enter Email Id"
            ></input>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: ".6rem",
              marginBottom: ".6rem",
            }}
          ></div>
          <div style={{ marginBottom: ".4rem" }}>
            <Button
              type="submit"
              sx={{
                width: "20rem",
                height: "3rem",
                backgroundColor: "#1A5AFA",
                color: "#ffffff",
              }}
              variant="contained"
            >
              Submit
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "1rem",
              justifyContent: "center",
            }}
          >
            <div
              onClick={() => {
                navigate("/login");
              }}
            >
              <span
                style={{ color: "#1A5AFA", cursor: "pointer", display: "flex" }}
              >
                <div style={{ marginRight: ".4rem", marginTop: ".1rem" }}>
                  <ArrowBackRoundedIcon />
                </div>
                <div
                  style={{
                    fontSize: "600",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h5>Back To Home</h5>
                </div>
              </span>
            </div>
          </div>
        </form>
      </div>
      {/* //backrgound molecule */}
      <div>
        <img
          src={Mask}
          style={{
            width: "100%",
            position: "absolute",
            bottom: "0",
            left: "0",
            zIndex: "0",
          }}
          alt="background Molecule"
        />
      </div>
    </div>
  );
  const handleCheckEmail = () => {
    window.open("mailto:");
  };

  //when email has been sent to the user..
  const EmailAlreadySent = (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background:
          "linear-gradient(180deg, #000000 12.64%, rgba(255, 255, 255, 0) 200.18%)",
      }}
    >
      <div
        style={{
          zIndex: "1",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "26rem",
          height: "auto",
          padding: "2.4rem",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        <div style={{ marginTop: "1.5rem" }}>
          <img src={checkEmail} alt="Login Top" />
        </div>
        <div style={{ marginTop: "1.5rem" }}>
          <span style={{ fontweight: "800", fontSize: "1.5rem" }}>
            Dev Labs Alliance
          </span>
        </div>
        <div style={{ marginTop: "1.5rem" }}>
          <span style={{ fontweight: "600", fontSize: "1.5rem" }}>
            Check Email
          </span>
        </div>
        <div>an email has been sent to </div>
        <div>
          <span style={{ fontSize: "1.4rem" }}>{email}</span>
        </div>
        {/* Form component here */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: ".6rem",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: ".6rem",
              marginBottom: ".6rem",
            }}
          ></div>
          <div style={{ marginBottom: ".4rem" }}>
            <Button
              type="submit"
              onClick={handleCheckEmail}
              sx={{
                width: "20rem",
                height: "3rem",
                backgroundColor: "#1A5AFA",
                color: "#ffffff",
              }}
              variant="contained"
            >
              Check Email
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "1rem",
              justifyContent: "center",
            }}
          >
            <div
              onClick={() => {
                setEmailSent(!emailSent);
              }}
            >
              <span
                style={{ color: "#1A5AFA", cursor: "pointer", display: "flex" }}
              >
                <div style={{ marginRight: ".4rem" }}>
                  <ArrowBackRoundedIcon />
                </div>
                <div>Back</div>
              </span>
            </div>
          </div>
        </form>
      </div>
      {/* //backrgound molecule */}
      <div>
        <img
          src={Mask}
          style={{
            width: "100%",
            position: "absolute",
            bottom: "0",
            left: "0",
            zIndex: "0",
          }}
          alt="background Molecule"
        />
      </div>
    </div>
  );

  return (
    <div>
      {emailSent
        ? // Render the EmailAlreadySent component when emailSent is true
          EmailAlreadySent
        : // Render the forgotPasswordCode component when emailSent is false
          forgotPasswordCode}
    </div>
  );
};

export default ForgotPassword;
